const roundDecimal = (num: number, decimalPoints = 3) => {
  const [, decimal] = num.toString().split('.')
  if (decimal && decimal.length > decimalPoints) {
    return parseFloat(num.toFixed(decimalPoints))
  }
  return num
}

export default roundDecimal
